import React from 'react';
import { Hero } from '../components/Hero';
import { LogoWall } from '../components/LogoWall';
import { ProductSuite } from '../components/ProductSuite';
import { Solutions } from '../components/Solutions';
import { FeatureSections } from '../components/FeatureSections';
import { Testimonial } from '../components/Testimonial';
import { DemoCta } from '../components/DemoCta';
import { Insights } from '../components/Insights';
export function Home() {
  return <main data-id="element-2066" data-mp="1zk20bsqx1efh">
      {/* One continuous background so the hero gradient fades into white with no seam. */}
      <div className="home-top-surface no-nav-offset w-full" data-id="element-2067" data-mp="24ivbvfmn6vd0">
        <Hero data-id="element-2068" data-mp="29fc2cghbdlt9" />
        <LogoWall data-id="element-2069" data-mp="29ettmkdgtf4g" />
      </div>
      <ProductSuite data-id="element-2070" data-mp="2dhqk0x98yfiy" />
      <Solutions data-id="element-2071" data-mp="2di8eppg9glor" />
      <FeatureSections data-id="element-2072" data-mp="2dirxt9hndg4d" />
      <Testimonial data-id="element-2073" data-mp="2dj1nsx2ozna2" />
      <DemoCta data-id="element-2074" data-mp="2dfdthvpfawua" />
      <Insights data-id="element-2075" data-mp="3kvk4whwqwx4x" />
    </main>;
}